export default class Transformation {

	constructor(public rotation: number, public deltaX: number, public deltaY: number) {
		if ([0, 90, 180, 270].indexOf(this.rotation) === -1)
			throw new Error('Rotation must be a multiple of 90');
	}

	public rotate90Right(): Transformation {
		return new Transformation((this.rotation + 90) % 360, this.deltaY, this.deltaX);
	}

	public increaseX(delta: number): Transformation {
		return new Transformation(this.rotation, this.deltaX + delta, this.deltaY);
	}

	public increaseY(delta: number): Transformation {
		return new Transformation(this.rotation, this.deltaX, this.deltaY + delta);
	}

	public decreaseX(delta: number): Transformation {
		return new Transformation(this.rotation, this.deltaX - delta, this.deltaY);
	}

	public decreaseY(delta: number): Transformation {
		return new Transformation(this.rotation, this.deltaX, this.deltaY - delta);
	}

	public isVerticallyRotated(): boolean {
		return this.rotation % 180 !== 0;
	}
}
